/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_CreatedInputs */

const en_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New event template created`)
};

const fr_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau modèle d'événement créé`)
};

const de_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisvorlage erstellt`)
};

const it_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo modello di evento creato`)
};

const ru_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан новый шаблон мероприятия.`)
};

const es_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva plantilla de evento creada`)
};

const zh_cn2_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建了新的活动模板`)
};

const ja_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントテンプレートが作成されました`)
};

const hi_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट टेम्प्लेट बनाया गया`)
};

const pt_pt2_context_menu_event_template_created = /** @type {(inputs: Context_Menu_Event_Template_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo modelo de evento criado`)
};

/**
* | output |
* | --- |
* | "New event template created" |
*
* @param {Context_Menu_Event_Template_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_created = /** @type {((inputs?: Context_Menu_Event_Template_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_event_template_created(inputs)
	if (locale === "de") return de_context_menu_event_template_created(inputs)
	if (locale === "it") return it_context_menu_event_template_created(inputs)
	if (locale === "ru") return ru_context_menu_event_template_created(inputs)
	if (locale === "es") return es_context_menu_event_template_created(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_event_template_created(inputs)
	if (locale === "ja") return ja_context_menu_event_template_created(inputs)
	if (locale === "hi") return hi_context_menu_event_template_created(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_event_template_created(inputs)
	return en_context_menu_event_template_created(inputs)
});